@use 'sass:map';
@use 'common/assets/scss/global' as *;
@import '@fortawesome/fontawesome-svg-core/styles.css';

.footer {
  > .top {
    background-color: var(--#{$prefix}basic-grey);

    > .container {
      display: flex;
      flex-direction: column;
      gap: 32px;
      text-align: center;
      padding-top: 34px;
      padding-bottom: 16px;

      > .logo {
        > img {
          max-height: 45px;
          width: auto;
          max-width: 100%;
        }
      }

      > .links {
        @include unstyled-list;
        font-size: var(--#{$prefix}font-size-sm);
        font-weight: 500;
        display: grid;
        gap: 18.5px;
        line-height: 1.2em;

        > li {
          > a {
            @include list-link;
            color: var(--#{$prefix}system-blue);
          }
        }
      }

      > .parteners {
        @include unstyled-list;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 44px;
        padding: 24px;

        > li {
          display: contents;

          > a {
            flex: 0 0 auto;
            display: inline-block;
            max-width: 100%;

            > img {
              display: block;
              height: 60px;
              max-width: 100%;
            }

            &:focus-visible {
              outline: 2px solid var(--#{$prefix}primary);
              border-radius: 3px;
            }
          }
        }
      }
    }
  }

  > .bottom {
    background-color: var(--#{$prefix}lighter-black);

    > .container {
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 32px;
      color: $white;
      padding-top: 16px;
      padding-bottom: 16px;

      > .links {
        @include unstyled-list;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        gap: 16px 32px;
        font-size: var(--#{$prefix}font-size-xs);
        line-height: 17px;

        > li > a {
          @include unstyled-link;

          &:hover,
          &:focus-visible {
            text-decoration: underline;
            outline: none;
          }
        }
      }

      > .made-by {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        font-size: var(--#{$prefix}font-size-xxs);
        text-align: center;

        > .fa-heart {
          height: 18px;
          width: 18px;
          margin: 2px;
          color: var(--#{$prefix}system-red);
        }
      }
    }
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    > .top > .container {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-evenly;
      gap: 32px;
      text-align: unset;
      padding-top: 36px;
      padding-bottom: 36px;

      > .logo {
        flex: 0 0 100%;
        display: flex;
        justify-content: center;
      }

      > .links {
        flex: 0 1 45%;
      }

      &:not(:has(> .links)) {
        > .parteners {
          flex-basis: unset;
        }
      }

      > .parteners {
        flex: 0 1 45%;
        gap: 16px;
        padding: unset;

        > li > a > img {
          max-height: 36px;
        }
      }
    }

    > .bottom > .container {
      flex-direction: row-reverse;
      justify-content: space-between;

      > .links {
        margin-left: 32px;
      }
    }
  }

  @media (width >= map.get($grid-breakpoints, lg)) {
    > .top > .container > .links {
      grid-template-columns: repeat(2, auto);
      gap: 16px 56px;
    }
  }

  @media (width >= map.get($grid-breakpoints, xl)) {
    > .top > .container {
      flex-wrap: nowrap;

      > .logo {
        flex: 0 1 auto;
      }
    }
  }
}
